export default __webpack_public_path__ + "static/media/logo.e6ecc3ec.png";